'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

WerkgeverselectieService.$inject = ['$q', 'WebApiService'];


var _module = _angular2.default.module('cb.core.forms.WerkgeverselectieService', []);

_module.factory('WerkgeverselectieService', WerkgeverselectieService);

exports.default = _module;


function WerkgeverselectieService($q, WebApiService) {
    return {
        getCookieValue: getCookieValue,
        setCookieValue: setCookieValue,
        clearCookie: clearCookie,
        getEmployer: getEmployer
    };

    function getCookieValue() {
        var sKey = 'EmployerId';
        return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || undefined;
    }

    function setCookieValue(employerid) {
        if (parseInt(employerid, 10)) {
            var date = new Date();
            date.setMonth(date.getMonth() + 3);

            document.cookie = 'EmployerId=' + employerid + ';expires=' + date + ';path=/';

            return true;
        } else {
            return false;
        }
    }

    function clearCookie() {
        document.cookie = 'EmployerId=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        return true;
    }

    function getEmployer(employerid) {
        if (!employerid) {
            return $q.when({});
        }

        var requestData = {
            WerkgeverId: employerid
        };

        return WebApiService.get(requestData, 'OphalenWerkgeverControl');
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/werkgeverselectie/werkgeverselectie.service.js
// module id = 802
// module chunks = 0